import { useAcceptVqaRequest, useRejectVqaRequest } from "./queries";

const OUTCOMES = {
  accepted: {
    success: "Join request accepted.",
    failure: "Could not accept this join request.",
  },
  rejected: {
    success: "Join request rejected.",
    failure: "Could not reject this join request.",
  },
};

/**
 * Accept / Reject a sponsor's join request from an admin action menu.
 * `notify(message, status)` shows the result; `onDecided(outcome)` runs after a success.
 */
export function useJoinRequestDecision({ notify, onDecided } = {}) {
  const { mutate: acceptMutate, isPending: accepting } = useAcceptVqaRequest();
  const { mutate: rejectMutate, isPending: rejecting } = useRejectVqaRequest();

  const callbacks = (outcome) => ({
    onSuccess: () => {
      notify?.(OUTCOMES[outcome].success, "success");
      onDecided?.(outcome);
    },
    onError: (err) => {
      notify?.(err?.response?.data?.message || OUTCOMES[outcome].failure, "error");
    },
  });

  return {
    accept: (id) => acceptMutate({ id }, callbacks("accepted")),
    reject: (id) => rejectMutate({ id }, callbacks("rejected")),
    isDeciding: accepting || rejecting,
  };
}
